// utils/layoutGraph.js
import dagre from 'dagre';

const nodeWidth = 172;
const nodeHeight = 36;
const nodeSpacingX = 80; // Horizontal spacing between nodes
const nodeSpacingY = 60; // Vertical spacing between nodes

export function layoutNodes(nodes, edges, direction = 'TB') {
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));
  dagreGraph.setGraph({ 
    rankdir: direction,
    nodesep: nodeSpacingX, // Horizontal separation between nodes
    ranksep: nodeSpacingY, // Vertical separation between nodes
    edgesep: 20 // Minimum separation between edges
  });

  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
  });

  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  const layoutedNodes = nodes.map((node) => {
    const { x, y } = dagreGraph.node(node.id);
    return {
      ...node,
      position: { x: x - nodeWidth / 2, y: y - nodeHeight / 2 },
      targetPosition: direction === 'LR' ? 'left' : 'top',
      sourcePosition: direction === 'LR' ? 'right' : 'bottom',
    };
  });

  return { nodes: layoutedNodes, edges };
}
